import { reject } from 'lodash';
import Vue from 'vue';
import router from '../router';
import store from '../store';
import * as imageConversion from 'image-conversion';

export const timeFix = lang => {
  const time = new Date();
  const hour = time.getHours();
  let morning, noon, afternoon, evening;
  switch (lang) {
    case 'zh_CN':
      morning = '早上好';
      noon = '中午好';
      afternoon = '下午好';
      evening = '晚上好';
      break;
    case 'en_US':
      morning = 'Good Morning';
      noon = 'Good Noon';
      afternoon = 'Good Afternoon';
      evening = 'Good Evening';
      break;
    default:
      break;
  }

  return hour < 9 ? morning : hour <= 11 ? morning : hour <= 13 ? noon : hour < 20 ? afternoon : evening;
};

/**
 * 校验身份证号合法性
 **/
export const checkIdNumberValid = num => {
  num = num.toUpperCase();

  var len, re;
  len = num.length;
  if (len === 0) return false;

  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
    return false;
  }

  // 验证前两位地区是否有效
  var aCity = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外'
  };

  if (aCity[parseInt(num.substr(0, 2))] === null) {
    return false;
  }

  // 当身份证为15位时的验证出生日期。
  if (len === 15) {
    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
    var arrSplit = num.match(re);

    // 检查生日日期是否正确
    var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
    var bGoodDay;
    bGoodDay =
      dtmBirth.getYear() === Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
      dtmBirth.getDate() === Number(arrSplit[4]);
    if (!bGoodDay) {
      return false;
    }
  }

  // 当身份证号为18位时，校验出生日期和校验位。
  if (len === 18) {
    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
    var arrSplit = num.match(re);
    // 检查生日日期是否正确
    var dtmBirth = new Date(arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
    var bGoodDay;
    bGoodDay =
      dtmBirth.getFullYear() === Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
      dtmBirth.getDate() === Number(arrSplit[4]);
    if (!bGoodDay) {
      return false;
    } else {
      // 检验18位身份证的校验码是否正确。
      // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      var valnum;
      var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
      var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
      var nTemp = 0,
        i;
      for (i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[nTemp % 11];
      if (valnum !== num.substr(17, 1)) {
        return false;
      }
    }
  }
  return true;
};

/**
 * 将数字变为指定长度的字符串，长度不足时在前面补 0
 * len = 2 ：1 -> '01'；12 -> '12'
 */
export const numberToLenStr = (number, len) => {
  const numberLen = String(number).length;
  if (numberLen < len) {
    const arr = new Array(len - numberLen).fill('0');
    return arr.join() + String(number);
  } else {
    return String(number);
  }
  return String(number).length === 1 ? `0${number}` : String(number);
};

/**
 * 防抖
 */
export const debounce = (fn, wait) => {
  var timer = null;
  return function() {
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments); // 把参数传进去
      clearTimeout(timer);
    }, wait);
  };
};
/**
 * 下载
 */
export const downLoadFileViaAjaxPost = (url, params, filName, fileType, callBack) => {
  // 随机生成10位随机数追加在Excel名称后面
  var randomNumber = String(Math.random()).substring(2, 12);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true); // 也可以使用POST方式，根据接口
  /**
   * 关于Blob 如何获取内容
   * https://developer.mozilla.org/zh-CN/docs/Web/API/Blob
   * reader.result 包含转化为类型数组的blob
   */
  xhr.responseType = 'blob'; // 返回类型blob
  xhr.setRequestHeader('Content-Type', 'application/json');

  // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
  xhr.onload = function() {
    // 请求完成
    if (this.status === 200) {
      // 返回200
      var blob = this.response;
      var reader = new FileReader();
      reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
      reader.onload = function(e) {
        // 转换完成，创建一个a标签用于下载
        var a = document.createElement('a');
        a.download = filName + '.' + fileType;
        a.target = '_blank';
        a.href = e.target.result;
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
      };
    }
    callBack();
  };
  // 以json格式为参数发送ajax请求
  xhr.send(JSON.stringify(params));
};

// 生成uuid
export const getUuid = () => {
  var s = [];
  var hexDigits = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  let uuid = s.join('');
  return uuid;
};

/**
 * 但数字长度大于 len 值时
 * 将数字以万为单位表示，来缩短数字长度，如：
 * len = 4
 * 9999 => 9999
 * 99999 => 9.99 (万)
 */
export const numberFomartToSample = (value, len = 0) => {
  if (!value) {
    return 0;
  }
  let decStr = '';
  if (value.toString().length > len) {
    value = Number(value) / 10000;
    if (value % 1 !== 0) {
      // value 不是整数
      const valueStrArr = value.toString().split('.');
      value = valueStrArr[0];
      const dec = valueStrArr[1].substr(0, 2);
      Number(dec) && (decStr = `.${dec}`);
    }
    return Number(value + decStr);
  }
  return value;
};

/**
 * 拆分 Promise.all 返回的成功、错误结果，并给出 notification
 * @param {vue} vm
 * @param {array} resArr [{promise, targetId}...]
 * @param {object} notifys
 * @  successMsg{string/function},
 * @  failMsg{string/function},
 * @  targets:[{id, name}...]
 * @return {object} {successRes, failRes}
 */
export const parsePromiseAllRes = (vm, resArr, notifys) => {
  // console.log('--', vm, resArr, notifys)
  const successRes = [],
    failRes = [];
  resArr.forEach(item => {
    if (item.res.status === 200) {
      successRes.push(item);
    } else {
      failRes.push(item);
    }
  });

  const { successMsg, failMsg, targets } = notifys;
  if (successMsg && successRes.length) {
    let message = notifys.successMsg;
    if (notifys.successMsg instanceof Function) {
      message = notifys.successMsg(successRes.length);
    }
    vm.$notification.success({ message });
  }

  if (failMsg && targets && targets.length && failRes.length) {
    let message = notifys.failMsg;
    if (notifys.failMsg instanceof Function) {
      message = notifys.failMsg(failRes.length);
    }

    vm.$notification.error({
      message,
      duration: 10,
      description: h => errDetails(h, failRes, notifys.targets)
    });
  }

  return { successRes, failRes };
};
// 构造错误的详细信息
function errDetails(h, failRes, targets) {
  const details = [];
  failRes.forEach(item => {
    const target = targets.find(target => target.id === item.targetId);
    details.push(
      h(
        'p',
        {
          style: { marginBottom: '5px' }
        },
        `${target.name}: ${item.res.response.data.message}`
      )
    );
  });
  console.log(details);
  // const details = failRes.map(item => {
  //   const name = targets.find(target => target.id === item.targetId).name
  //   const message = item.res.response.data.message
  //   return h('p', {
  //     style: { marginBottom: '5px' }
  //   }, `${name}: ${message}`)
  // })
  return h('div', details);
}

/**
 * 使用 image-conversion 上传压缩图片
 * @param {*} file 需要压缩的图片
 * @param {*} options 选填，压缩配置; 成员：
 * @ largestSide 限制最大边长，单位px, 默认 1080
 * @ maxSize 限制最大体积，单位kb, 默认 300
 * @ fixedW 选填，固定宽
 * @ fixedH 选填，固定高
 * @param {Function} callback 必填，回调函数
 */
export const compressImageFile = async (file, options, callback) => {
  if (typeof options === 'object') {
    options = { maxSize: 300, largestSide: 1080, ...options };
  } else if (typeof options === 'function') {
    callback = options;
    options = { maxSize: 300, largestSide: 1080 };
  } else {
    throw new Error('Parameter options error!');
  }

  if (!callback) throw new Error('Missing callback function!');

  const { maxSize, largestSide, fixedW, fixedH } = options;
  const img = await getImageByFileReader(file);
  if (!maxSize) {
    callback(img);
    return;
  }

  let width = img.width,
    height = img.height;
  if (largestSide && Math.max(img.width, img.height) > largestSide) {
    if (img.width > img.height) {
      width = 1080;
      height = (1080 * img.height) / img.width;
    } else {
      height = 1080;
      width = (1080 * img.width) / img.height;
    }
  }
  if (fixedW && fixedH) {
    width = fixedW;
    height = fixedH;
  }

  const res = await imageConversion.compressAccurately(file, { size: maxSize, width, height });
  // console.log('--', res, (res instanceof File))
  if (res instanceof File) {
    const resImg = await getImageByFileReader(res);
    callback(resImg);
  } else {
    const resFile = new File([res], file.name, {
      type: res.type,
      uid: file.uid,
      lastModified: Date.now()
    });
    resFile.uid = file.uid;
    const resImg = await getImageByFileReader(resFile);
    callback(resImg);
  }
};
/**
 * 通过 FileReader 来获取上传图片的信息
 * @params {file} file 上传的文件
 * @return {promise} promise
 */
function getImageByFileReader(file) {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const image = new Image();
        image.onerror = reject;
        image.src = e.target.result;
        image.onload = () => {
          resolve({
            uid: file.uid,
            name: file.name,
            type: file.type,
            size: file.size,
            base64: image.src,
            width: image.width,
            height: image.height
          });
        };
      };
      fileReader.readAsDataURL(file);
    } catch (error) {
      reject(error);
    }
  });
}
/**
 * 通过传入的图片 base64, 生成一个 image 对象并返回 image 的相关信息
 * @param {string} base64
 * @return {promise} promise
 */
function getImageByBase64(base64) {
  return new Promise((resolve, reject) => {
    try {
      const image = new Image();
      image.src = base64;
      image.onload = () => {
        resolve({
          type: base64.replace(/data:([^;]+).*/i, '$1'),
          size: base64ImageSize(base64),
          base64: image.src,
          width: image.width,
          height: image.height
        });
      };
    } catch (error) {
      reject(error);
    }
  });
}
/**
 * 计算 base64 图片大小
 * @param {*} base64Str base64 字符串
 * @param {*} isKB 返回值单位是否为 KB；否，则是 B，
 * @return {*} size base64 图片大小
 */
function base64ImageSize(base64Str, isKB) {
  const indexBase64 = base64Str.indexOf('base64,');
  if (indexBase64 < 0) return -1;
  const str = base64Str.substr(indexBase64 + 6);

  if (isKB) {
    return (str.length * 0.75).toFixed(2) / 1024;
  } else {
    return (str.length * 0.75).toFixed(2);
  }
}
/**
 * 重置 form 表单的验证，不会像原本的 resetFields 重置值
 * @param { vue } vm 组件实例
 * @param { string } form 组件中表单 Form 的对象名
 * @param { boolean } revalidate 是否重新校验；默认 true
 */
export const resetFormValidate = (vm, formName, revalidate = true) => {
  const form = vm[formName];
  const formFileds = form.getFieldsError();

  let errFileds = [];
  Object.keys(formFileds).forEach(name => {
    if (formFileds[name]) errFileds.push(name);
  });

  if (errFileds.length) {
    const errFiledsValue = form.getFieldsValue(errFileds);

    form.resetFields(errFileds);
    form.setFieldsValue(errFiledsValue);

    revalidate &&
      vm.$nextTick(() => {
        form.validateFields(errFileds, () => {});
      });
  }
};

/**
 * 清理列表选中项
 * @param { string } id 清理选中项的 id；无 id 时，清理全部
 * @param { array } keys 选中项的 id 数组
 * @param { array } items 选中项数组
 */
export const deleteSelectedRow = (id, keys = [], items = []) => {
  if (id) {
    const i = keys.indexOf(id);
    if (i !== -1) {
      keys.splice(i, 1);
      items.splice(i, 1);
    }
  } else {
    keys.length = 0;
    items.length = 0;
  }
};


export const deepClone =  obj => {
  let objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === "object") {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        //判断ojb子元素是否为对象，如果是，递归复制
        if (obj[key] && typeof obj[key] === "object") {
          objClone[key] = deepClone(obj[key]);
        } else {
          //如果不是，简单复制
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone
}
//获取当前日期函数
export const  getNowFormatDate = () => {
  let date = new Date(),
    year = date.getFullYear(), //获取完整的年份(4位)
    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
    strDate = date.getDate() // 获取当前日(1-31)
  if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
  if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

  return `${year}-${month}-${strDate}`
}
